import type { Components } from '@mui/material/styles';

export default function MuiAccordionDetails(): Components['MuiAccordionDetails'] {
  return {
    styleOverrides: {
      root: {
        padding: 0,
      },
    },
  };
}
